import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import {
  POST_PROFILE_DATA,
  POST_PROFILE_IMG,
} from "../../config/ApisCollection";
import Validations from "../../config/Validations.json";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ProfileInfoUpdate() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const [userName, setUserName] = useState("");
  const [phoneno, setPhoneno] = useState("");
  const [email, setEmail] = useState("");
  const [profileImg, setProfileImg] = useState("");
  const [userAge, setUserAge] = useState("");
  const [height, setHeight] = useState("");
  const [goal, setGoal] = useState("");
  const [goalDate, setGoalDate] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrorMsg = { ...errorMsg }; // Copying the current error message state
    setContinueBtn(true);
    switch (name) {
      case "email":
        if (validateEmail(value)) {
          setEmail(value);
        } else {
          setContinueBtn(false);
          newErrorMsg.email = "Please enter a valid email address.";
        }
        break;
      case "name":
        setUserName(value.replace(/[^a-zA-Z\s]/g, "")); // Allow only alphabets and spaces
        if (/\d/.test(value)) {
          newErrorMsg.userName = "First Name should not contain numbers.";
          setContinueBtn(false);
        } else {
          newErrorMsg.userName = null;
        }
        break;
      case "phoneno":
        setPhoneno(value);
        break;
      default:
        break;
    }
    if (userName.length == 0 || email.length == 0) {
      setContinueBtn(false);
    }
    setErrorMsg(newErrorMsg); // Updating the error message state
  };

  const handleGoAHead = () => {
    let newErrorMsg = { ...errorMsg }; // Copying the current error message state
    // Check if First Name is empty
    if (!userName.trim()) {
      newErrorMsg.userName = "Name is required.";
    } else {
      newErrorMsg.userName = null; // Clear the error message if First Name is not empty
    }
    if (!email.trim()) {
      newErrorMsg.email = "Email is required.";
    } else {
      newErrorMsg.email = null; // Clear the error message if First Name is not empty
    }

    setErrorMsg(newErrorMsg); // Updating the error message state

    // If there are no errors, proceed with form submission
    if (!newErrorMsg.userName && !newErrorMsg.email) {
      let data = {
        userName: userName,
      };
      postProfileData();
    }
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(1));
  };

  const postProfileImage = async (e) => {
    const live_url = POST_PROFILE_IMG;
    const fileInput = e.target.files[0];
    const form_data = new FormData();
    form_data.append("userProimg", fileInput);

    if (
      (fileInput.type === "image/jpg" ||
        fileInput.type === "image/jpeg" ||
        fileInput.type === "image/png") &&
      fileInput.size <= Validations.img_fileSize_byte
    ) {
      const imageBody = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        body: form_data,
      };

      await fetch(live_url, imageBody)
        .then((imageRes) => imageRes.json())
        .then((imageResult) => {
          if (imageResult.status === 200) {
            secureLocalStorage.removeItem("profileDetails");
            toast.success(imageResult.message);
            setProfileImg(URL.createObjectURL(e.target.files[0]));
          } else if (imageResult["error"]) {
            if (imageResult["error"].message === "token expired") {
              toast.error(imageResult["error"].message);
            }
          } else {
            toast.error(imageResult.error.message);
          }
        })
        .catch((imageErr) => {});
    } else {
      //  "File size must be less than " + Validations.img_fileSize_byte / 1024;
    }
  };

  const postProfileData = async () => {
    // e.preventDefault();
    const userName1 = userName;
    const userPhone1 = phoneno;
    const live_url = POST_PROFILE_DATA;
    const postBody = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        userName: userName1,
        userPhone: userPhone1,
      }),
    };

    await fetch(live_url, postBody)
      .then((postRes) => postRes.json())
      .then((postResult) => {
        if (postResult["error"]) {
          if (postResult["error"].message === "token expired") {
            toast.error(postResult["error"].message);
          } else {
            //postResult.error.message
            toast.error(postResult.error.message);
          }
        } else {
          //  postResult.message;
          secureLocalStorage.removeItem("profileDetails");
          toast.success(postResult.message);
        }
      })
      .catch((postErr) => {
        console.log(postErr);
      });
  };

  useEffect(() => {
    if (profileDetails) {
      setUserName(profileDetails?.name);
      setEmail(profileDetails?.email);
      setPhoneno(profileDetails?.phone);
      setHeight("5 ' 7\"");
      setUserAge("25");
      setGoal("Vacation");
      setGoalDate("25 Nov 2023");
      setProfileImg(profileDetails.image);
      // console.log(profileDetails);
    }
  }, [profileDetails]);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="bodyly spwok pb-8 gap-6 flex flex-col justify-between">
        <div className="profileinfo px-8">
          <ToastContainer />
          <div className="d">
            <div className="flex justify-center flex-col">
              <div className="self-center">
                <img src={profileImg} className="" width={150} height={150} />
              </div>

              <label
                htmlFor="myfile"
                className="text-center w-6/12 mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl mt-10 mb-10"
              >
                Choose file
              </label>
              <input
                type="file"
                id="myfile"
                name="myfile"
                accept=".jpg,.png,.jpeg"
                onChange={postProfileImage}
                hidden
              />
            </div>
          </div>
          <div className="my-2 mb-1">
            <span className="text-sm ml-1 font-semibold text-black">
              Full Name
            </span>
            <input
              type="text"
              placeholder="Enter Name"
              name="name"
              onChange={handleChange}
              defaultValue={userName || ""}
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
            />
          </div>
          <div className="my-2 mb-1" hidden>
            <span className="text-sm ml-1 font-semibold text-black">
              Your Email
            </span>
            <input
              type="email"
              placeholder="Enter Email"
              name="email"
              onChange={handleChange}
              defaultValue={email || ""}
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
            />
          </div>
          <div className="my-2 mb-1">
            <span className="text-sm ml-1 font-semibold text-black">
              Your Phone Number
            </span>
            <input
              type="text"
              placeholder="Enter number"
              maxLength={10}
              name="phoneno"
              onChange={handleChange}
              defaultValue={phoneno || ""}
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
            />
          </div>
        </div>

        <button
          onClick={handleGoAHead}
          className="text-center w-10/12 mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl"
        >
          <p className="text-lg text-white font-medium">Update profile</p>
        </button>
      </div>
    </div>
  );
}
